import { ENVIRONMENT } from "../../../../environments/environment";

if (ENVIRONMENT.overrideDomain) {
  document.domain = ENVIRONMENT.overrideDomain;
}
